// useSearchApi.js
import axios from "@/axios"; // make sure the path is correct
import axiosDown from "@/axiosDown"; // make sure the path is correct
import axiosSync from "@/axiosSync"; // make sure the path is correct

export function useSearchApi() {
  async function getOltBnd(id) {
    const response = await axios.get(`/getoltbnd/?fendy_user_id=${id}`);
    return response.data;
  }

  async function getGponMacFiend(mac, id) {
    const response = await axios.get(`/bdcom-gpon/mac-finder/?mac=${mac}&oltid=${id}`);
    return response.data;
  }

  async function getEponMacFiend(mac, id) {
    const response = await axios.get(`/bdcom-epon/mac-finder/?macaddr=${mac}&oltid=${id}`);
    return response.data;
  }

  async function getVsolEponMacFiend(mac, id) {
    const response = await axios.get(`/vsol-epon/mac-finder/?oltid=${id}&macaddr=${mac}&diagnostic=true`);
    return response.data;
  }

  async function getAviesMacFiend(mac, id) {
    const response = await axios.get(`/avies-epon/mac-finder/?oltid=${id}&macaddr=${mac}`);
    return response.data;
  }

  async function getCdataMacFiend(mac, id) {
    const response = await axios.get(`/cdata-epon/mac-finder/?oltid=${id}&macaddr=${mac}`);
    return response.data;
  }

  async function getBdcomGponLosFinder(id) {
    const response = await axios.get(`/bdcom-gpon/onu-loss-finder/?oltid=${id}`);
    return response.data;
  }

  async function getBdcomEponLosFinder(id) {
    const response = await axios.get(`/bdcom-epon/onu-loss-finder/?oltid=${id}`);
    return response.data;
  }

  async function getVsolEponLosFinder(id) {
    const response = await axios.get(`/vsol-epon/onu-loss-finder/?oltid=${id}`);    
    return response.data;
  }
  async function getVsolGponLosFinder(id) {
    // const response = await axios.get(`/vsol-gpon/onu-loss-finder/?oltid=${id}`);
    const response = await axiosSync.get(`/vsol-gpon/api?oltid=${id}&type=fiberdowndetact&url=${process.env.VUE_APP_API_BASE_URL}`);
    return response.data;
  }
  async function getAviesEponLosFinder(id) {
    const response = await axios.get(`/avies-epon/onu-loss-finder/?oltid=${id}`);
    return response.data;
  }

  async function geOnuLoss(id, port) {
    const response = await axios.get(`/api/port-data/onu-loss/?oltid=${id}&port_number=${port}`);
    return response.data;
  }

  const uid = JSON.parse(localStorage.getItem("user_data"))?.fendy_user_id ?? '';

   async function getLogListData(page) {
        try {
          // const response = await axiosDown.get(`/api/session-log-summary/${39027}/?page=${page}`);
          const response = await axiosDown.get(`/api/session-log-summary/${uid}/?page=${page}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving log:", error);
          throw error; 
        }
      }

  async function getSingleUserDb(pppoe) {
    
        try {
          const response = await axios.get("/filter_by_pppoe_id/api/", {
            headers: {
              'X-Custom-Header': pppoe
            }
          });
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }

  async function getLogsDateList(ppoe) {
        try {
          const response = await axios.get(`/api/olt-data-logs/?PPPOE_ID=${ppoe}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getDownHistryList(pppoe_id) {
        try {
          const response = await axiosDown.get(`/api/session-log/history/${uid}/${pppoe_id}/`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getDownDelList(pppoe_id) {
        try {
          const response = await axiosDown.delete(`/api/session-log/dell/${uid}/${pppoe_id}/`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getDiscountList() {
        try {
          const response = await axios.get(`/api/events/`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }

  async function getRealtimeValueAll(olt_id) {
        try {
          const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=realtimevlaueall&url=${process.env.VUE_APP_API_BASE_URL}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getCloudEdponDown(olt_id) {
        try {
          const response = await axiosSync.get(`cdata-epon-cloude/api?oltid=${olt_id}&dta=fiberdown&url=${process.env.VUE_APP_API_BASE_URL}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getCdataMacFinder(olt_id,search) {
        try {
          const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=macfind&macaddr=${search}&url=${process.env.VUE_APP_API_BASE_URL}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getCdataGponCloudeMacFinder(olt_id,search) {
        try {
          const response = await axiosSync.get(`/cdata-gpon-cloude/api?dta=macwithonu&oltid=${olt_id}&MacAddr=${search}&url=${process.env.VUE_APP_API_BASE_URL}`);
          // const response = await axiosSync.get(`/cdata-v1-2/api/olt/portinfo?oltid=${olt_id}&dta=macfind&macaddr=${search}&url=${process.env.VUE_APP_API_BASE_URL}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }
  async function getCdataCloudeMacFinder(olt_id,search) {
        try {
          const response = await axiosSync.get(`/cdata-epon-cloude/api?oltid=${olt_id}&dta=macfind&MacAddr=${search}&url=${process.env.VUE_APP_API_BASE_URL}`);
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }

  async function updateDiscountList() {
        try {
          const response = await axios.put(`/api/userprofile/update-event-status/`,
            {
              "is_active_event": false
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error retrieving user:", error);
          throw error; 
        }
      }

  return {
    getOltBnd,
    getGponMacFiend,
    getEponMacFiend,
    getVsolEponMacFiend,
    getAviesMacFiend,
    getCdataMacFiend,
    getBdcomGponLosFinder,
    getBdcomEponLosFinder,
    getVsolEponLosFinder,
    getVsolGponLosFinder,
    getAviesEponLosFinder,
    geOnuLoss,
    getLogListData,
    getSingleUserDb,
    getLogsDateList,
    getDownHistryList,
    getDownDelList,
    getDiscountList,
    updateDiscountList,
    getRealtimeValueAll,
    getCdataMacFinder,
    getCdataGponCloudeMacFinder,
    getCloudEdponDown,
    getCdataCloudeMacFinder
  };
}
